import BalanceRow from '@components/BalanceRow'
import { PerpActivity } from '@plug-core/hooks/perps/usePerpActivity'
import useConfig from '@plug-core/hooks/useConfig'
import { formatMoney } from '@plug-core/utils/formatNumber'
import React from 'react'

const PerpActivityRow = ({ perpActivity }: { perpActivity: PerpActivity }) => {
  const { tokens } = useConfig()
  const perpToken = tokens.find(
    (t) => t.additionalData.hyperliquidId === perpActivity.perpTokenId?.toString()
  )

  return (
    <BalanceRow
      logo={perpToken?.logo}
      title={perpActivity.direction}
      subtitle={`${perpToken?.symbol}-USD`}
      value={perpActivity.pnl ? formatMoney(perpActivity.pnl) : undefined}
    />
  )
}

export default PerpActivityRow
